<template lang="html">

  <section class="banner-novedades-home" :empty="promociones.length == 0 && noticias.length == 0">


    <div class="contenedor-novedades container row-start" v-if="noticias.length != 0">
      <img ref="newspaper" src="/static/img/encabezado-novedades.png"
        alt="Novedades Top" class="periodico">
        <div class="contenedor-noticia">
          <noticia :data="noticias[0]" v-if="noticias.length != 0"></noticia>
          <img src="/static/img/lazo-3.png" class="lazo-3">
          <img src="/static/img/lazo-4.png" class="lazo-4">
          <img src="/static/img/lazo-5.png" class="lazo-5">
          <router-link :to="$t('enlaces.novedades')" class="btn-enviar -enviar-pink">{{$t('novedades.ver_mas')}}</router-link>
        </div>
    </div>


    <div class="contenedor-promociones-home container row-start" v-if="promociones.length != 0">
      <h2 class="secondary-title">{{$t('promociones.destacada')}}</h2>
      <div class="container">
        <promocion :data="promociones[0]"></promocion>
        <router-link :to="$t('enlaces.promociones')" class="btn-enviar -enviar-pink">{{$t('promociones.ver_mas')}}</router-link>
      </div>

    </div>


  </section>

</template>

<script lang="js">

    import {mapGetters, mapActions} from 'vuex'

    import noticia from '@/components/parts/noticia-el';

    import promocion from '@/components/parts/promocion-el';
 
     export default  {
       name: 'banner-novedades',
       computed : {
        ...mapGetters({
          noticias : 'getNoticias',
          promociones : 'getpromociones',
        }),
      },
      components : {
        'noticia' : noticia,
        'promocion' : promocion
      }
       
     }
   </script>
<style scoped lang="scss">
 
   </style>


// WEBPACK FOOTER //
// src/components/parts/banner-novedades.vue